import { buildTurfDetailRoute } from "./turfRoutes";

// Extract turf username and city from banner URL
export const extractBannerInfo = (bannerSrc: string): { city: string | null; turfUsername: string | null } => {
  const match = bannerSrc.match(/\/all_banners\/([^\/]+)\/([^\/]+)\/(desktop|mobile)\//);
  if (match) {
    return { city: match[1]?.toLowerCase() || null, turfUsername: match[2] || null };
  }
  return { city: null, turfUsername: null };
};

// Check if banner is for pavilion (multiple locations)
export const isPavilionBanner = (bannerSrc: string): boolean => {
  const { turfUsername } = extractBannerInfo(bannerSrc);
  if (!turfUsername) return false;
  
  const pavilionUsernames = ['pavilion-turf-mahalaxmi-nagar', 'pavilion-turf-nipania', 'pavilion-turf-dewas-naka'];
  return pavilionUsernames.some(name => turfUsername.toLowerCase().includes(name.toLowerCase()));
};

// Find turf in data and get the internal route URL
export const getTurfRouteFromBanner = (
  bannerSrc: string, 
  turfData: any[]
): { isPavilion: boolean; url: string | null; turfUsername: string | null } => {
  if (isPavilionBanner(bannerSrc)) {
    return { isPavilion: true, url: null, turfUsername: null };
  }
  
  const { city, turfUsername } = extractBannerInfo(bannerSrc);
  if (!turfUsername || !city) return { isPavilion: false, url: null, turfUsername: null };
  
  // Find turf by username
  const turf = turfData.find(t => t.userName?.toLowerCase() === turfUsername.toLowerCase());
  if (!turf?.data?.areaPrice?.[0]?.pitchName) {
    return { isPavilion: false, url: null, turfUsername };
  }
  
  const pitchName = turf.data.areaPrice[0].pitchName;
  const url = buildTurfDetailRoute({
    city: turf.data.city || city,
    userName: turfUsername,
    pitchName,
    areaName: turf.data.areaName,
  });
  
  return { isPavilion: false, url, turfUsername };
};

// Legacy function for backward compatibility
export const handleBannerRedirect = (bannerSrc: string): { isPavilion: boolean; turfName?: string } => {
  if (isPavilionBanner(bannerSrc)) return { isPavilion: true };
  const { turfUsername } = extractBannerInfo(bannerSrc);
  return { isPavilion: false, turfName: turfUsername || undefined };
};